import UAParser from 'ua-parser-js';

var parser = new UAParser();
var result = parser.getResult();

function addClass(category, value) {
	value = value.toString().toLowerCase().replace(/[\s.]/g, '-');

	document.documentElement.classList.add('is-' + category + '-' + value);
}

if (result.device.model) {
	addClass('device', result.device.model);
}

if (result.device.type) {
	addClass('device', result.device.type);
} else {
	addClass('device', 'desktop');
}

if (result.os.name) {
	if (['fedora', 'debian', 'gentoo', 'linpus', 'mageia', 'mandriva', 'meego', 'mint', 'pclinuxos', 'redhat', 'sailfish', 'slackware', 'suse', 'tizen', 'ubuntu', 'vectorlinux'].includes(result.os.name.toLowerCase())) {
		addClass('os', 'linux');
	}

	addClass('os', result.os.name);

	if (result.os.version) {
		addClass('os', result.os.name + '-' + result.os.version);
	}
}

if (result.engine.name) {
	addClass('engine', result.engine.name);
}

if (result.browser.name) {
	addClass('browser', result.browser.name);

	if (result.browser.major) {
		addClass('browser', result.browser.name + '-' + result.browser.major);
	}
}

export default UAParser;
